









































































import { Component, Vue } from "vue-property-decorator";
import SectionContainer from "@/components/Commons/SectionContainer.vue";
import SectionTitle from "@/components/Commons/SectionTitle.vue";
import { vxm } from "@/store.vuex";
declare var window: any;

@Component({
  components: {
    SectionContainer,
    SectionTitle,
  },
})
export default class Help extends Vue {
  get supportPhoneNo() {
    return (
      vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') || vxm.utility.supportPhoneNo
    );
  }
  get otherSupportEmail() {
    return vxm.configs.getGlobalConfigValue('OTHER_SUPPORT_EMAIL');
  }
  get otherSupportNumber() {
    return (
      vxm.configs.getGlobalConfigValue('OTHER_SUPPORT_PHONE_NUMBER') &&
      vxm.configs.getGlobalConfigValue('OTHER_SUPPORT_PHONE_NUMBER').split(':')
    );
  }
  get otherMailUsHref() {
    const subject = `Message from ${vxm.users.myUserProfile.email}`;
    const newLine = "%0D%0A";
    const body = `Hello ${this.companyName},${newLine}${newLine}Best Regards,${newLine}${vxm.users.myUserProfile.firstName} ${vxm.users.myUserProfile.lastName}`;
    return `mailto:${this.otherSupportEmail}?subject=${subject}&body=${body}`;
  }
  get canShowCustTechnicalSupport() {
    return vxm.configs.getGlobalConfigValue('SHOW_CUSTOMER_BASED_TECH_SUPPORT')
  }
  multiTelHref(value: string) {
    return `tel:${value}`;
  }
  get supportEmail() {
    return vxm.configs.getGlobalConfigValue('SUPPORT_EMAIL') || vxm.utility.supportEmail;
  }
  get telHref() {
    return `tel:${this.supportPhoneNo}`;
  }
  get dynamicPrivacyPolicyText(){
    return vxm.configs.getGlobalConfigValue('DYNAMIC_PRIVACY_POLICY_TEXT') || this.$t('help.privacypolicy');
  }

  get mailUsHref() {
    const subject = `Message from ${vxm.users.myUserProfile.email}`;
    const newLine = "%0D%0A";
    const body = `Hello ${this.companyName},${newLine}${newLine}Best Regards,${newLine}${vxm.users.myUserProfile.firstName} ${vxm.users.myUserProfile.lastName}`;
    return `mailto:${this.supportEmail}?subject=${subject}&body=${body}`;
  }

  get companyName() {
    return vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
    );
  }
  get learnMoreUrl() {
    return vxm.configs.getGlobalConfigValue(
      'CANDIDATE_PORTAL_LEARN_MORE_END_POINT_URL',
    );
  }
  get showSupportPhoneNumber(): boolean {
    return vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') ? true : false;
  }

  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  get helpForAllOther() {
      return (
      vxm.configs.getGlobalConfigValue('HELP_FORALL_OTHER') ||
        this.$t('help.forallother')
      );
    }
}
